import initialTaskState from "../task.initialState"
import { reduxActions as TASK } from "_constants/task.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const items = {
  [TASK.ITEMS_STARTED]: (state) => ({
    ...state,
    items: {
      ...state.items,
      status: LOADING
    }
  }),

  [TASK.ITEMS_FAIL]: (state, { payload }) => ({
    ...state,
    items: {
      ...state.items,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [TASK.ITEMS_SUCCESS]: (state, { payload }) => ({
    ...state,
    items: {
      ...state.items,
      data: payload?.data ?? null,
      status: SUCCESS
    }
  }),

  [TASK.ITEMS_REFRESH]: (state, { payload }) => ({
    ...state,
    items: {
      ...state.items,
      data: state.items.data?.map((task) => {
        if (task?._id === payload._id) {
          return {
            ...task,
            ...payload.c
          };
        }
        
        return task;
      }) ?? null
    }
  }),

  [TASK.ITEMS_RESET]: (state) => ({
    ...state,
    items: initialTaskState.items
  })
};

export default items;
